import { render, staticRenderFns } from "./edit-old.vue?vue&type=template&id=60b72102&scoped=true"
import script from "./edit-old.vue?vue&type=script&lang=js"
export * from "./edit-old.vue?vue&type=script&lang=js"
import style0 from "./edit-old.vue?vue&type=style&index=0&id=60b72102&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b72102",
  null
  
)

export default component.exports